module.exports = __webpack_public_path__ + "static/WEDDING E&M-364-125ec555cafd5989639e5a5878b9a80a.jpg";